// store/documentUploadSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    aadhaarFront: null,
    aadhaarBack: null,
    panCard: null,
    previews: {
        aadhaarFront: null,
        aadhaarBack: null,
        panCard: null,
    },
};

const documentUploadSlice = createSlice({
    name: 'documentUpload',
    initialState,
    reducers: {
        setFile(state, action) {
            const { field, file, preview } = action.payload;
            state[field] = file;
            state.previews[field] = preview;
        },
        resetFiles(state) {
            state.aadhaarFront = null;
            state.aadhaarBack = null;
            state.panCard = null;
            state.previews = {
                aadhaarFront: null,
                aadhaarBack: null,
                panCard: null,
            };
        },
    },
});

export const { setFile, resetFiles } = documentUploadSlice.actions;
export default documentUploadSlice.reducer;
